import { render, staticRenderFns } from "./factura_constructor_tabla.vue?vue&type=template&id=0f76d6ac&scoped=true"
import script from "./factura_constructor_tabla.vue?vue&type=script&lang=js"
export * from "./factura_constructor_tabla.vue?vue&type=script&lang=js"
import style0 from "./factura_constructor_tabla.vue?vue&type=style&index=0&id=0f76d6ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../cliente_administracion/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f76d6ac",
  null
  
)

export default component.exports